import { useQuery } from '@tanstack/react-query';
import { useAppConfigContext } from '@/context/AppConfig';
import { request } from '@/utils/index';

interface LocationResponse {
  entities?: {
    locations?: {
      longitude?: number;
      latitude?: number;
    }[];
  };
}

export function useLocationInterface(zip: string, submitted: boolean) {
  const { logError } = useAppConfigContext();

  const result = useQuery({
    queryKey: ['locationInterface'],
    queryFn: () => getDisclaimer(zip),
    onError: (error) => {
      logError('Error fetching location', error as Error);
    },
    enabled: Boolean(zip) && submitted,
  });

  return { ...result };
}

async function getDisclaimer(zip: string) {
  const url = `/hk/dd/v2/location?dd_plan=riverside&zip5=${zip}`;

  const response = await request(url, {
    headers: new Headers({
      'content-type': 'application/json',
    }),
    method: 'GET',
  });

  const location = response?.entities?.locations[0];
  return location;
}

export async function getCoordinates(city: string, state: string) {
  const request = await fetch(
    `/hk/dd/v2/location?state=${state}&city=${city}&country=US`
  );

  if (!request.ok)
    throw new Error(`Failed to fetch location endpont. ${request.status}`);

  const response: LocationResponse = await request.json();

  return {
    longitude: response.entities?.locations?.[0]?.longitude,
    latitude: response.entities?.locations?.[0]?.latitude,
  };
}
